import { SITE } from "../data";

export default function ContactSection() {
  return (
    <section id="contact" className="bg-primary-500 text-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-[11px] font-label tracking-[0.2em] uppercase text-primary-100 mb-3">
              <span className="w-6 h-px bg-primary-100" />
              Contact
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black leading-tight">
              联系我们
            </h2>
            <p className="mt-4 text-sm md:text-base text-primary-100 leading-relaxed max-w-xl">
              对赛事规则、参赛条件或评选标准还有疑问？欢迎随时来信。
              我们通常会在 1 个工作日内回复，涉及作品复核的问题会优先处理。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href={`mailto:${SITE.email}`}
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-background-50 text-primary-700 text-sm md:text-base font-medium whitespace-nowrap hover:bg-accent-100 transition-colors"
              >
                <i className="ri-mail-send-line text-lg" aria-hidden="true"></i>
                发送邮件
              </a>
              <a
                href="#faq"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md border border-background-50/40 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors"
              >
                先看常见问题
              </a>
            </div>
          </div>

          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="p-5 rounded-lg bg-primary-600/50 border border-primary-400/40">
              <dt className="text-xs text-primary-100 flex items-center gap-1.5">
                <i className="ri-mail-line" aria-hidden="true"></i>赛事邮箱
              </dt>
              <dd className="mt-2 text-sm md:text-base font-bold break-all">{SITE.email}</dd>
            </div>
            <div className="p-5 rounded-lg bg-primary-600/50 border border-primary-400/40">
              <dt className="text-xs text-primary-100 flex items-center gap-1.5">
                <i className="ri-wechat-line" aria-hidden="true"></i>官方微信
              </dt>
              <dd className="mt-2 text-sm md:text-base font-bold break-all">{SITE.wechat}</dd>
            </div>
            <div className="p-5 rounded-lg bg-primary-600/50 border border-primary-400/40">
              <dt className="text-xs text-primary-100 flex items-center gap-1.5">
                <i className="ri-time-line" aria-hidden="true"></i>响应时间
              </dt>
              <dd className="mt-2 text-sm md:text-base font-bold">工作日 1 天内回复</dd>
            </div>
            <div className="p-5 rounded-lg bg-primary-600/50 border border-primary-400/40">
              <dt className="text-xs text-primary-100 flex items-center gap-1.5">
                <i className="ri-calendar-line" aria-hidden="true"></i>当前赛季
              </dt>
              <dd className="mt-2 text-sm md:text-base font-bold">{SITE.season}</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}